import $ from "@modules/jquery";

export default function HamburgerMenu() {
    const $body = $("body");
    const $searchLayer = $('#search-layer');
    const $btnOpen = $('#menu-btn-search-open');
    const $btnClose = $('#menu-btn-search-close');

    $btnOpen.on('click', () => {
        $searchLayer.fadeIn(100, () => {
            $searchLayer.attr({
                'aria-hidden': 'false',
                'aria-modal': 'true',
                'role': 'dialog'
            });
            $searchLayer.find('input, button, [tabindex]:not([tabindex="-1"])').first().trigger('focus');
        });

        $body.addClass("overflow-hidden");
    });

    $btnClose.on('click', () => {
        $searchLayer.fadeOut(100, () => {
            $searchLayer.attr('aria-hidden', 'true');
            $btnOpen.trigger('focus'); // ritorno del focus al bottone apri
        });

        $body.removeClass("overflow-hidden");
    });

    // Optional: chiusura con ESC
    $(document).on('keydown', (e) => {
        if (e.key === 'Escape' && $searchLayer.is(':visible')) {
            $btnClose.trigger('click');
        }
    });
}
